import React from 'react';
import { Link } from 'react-router-dom';

function BreadCrumb() {
  return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title">Classifieds in India</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/Admin" className="breadcrumb-link">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
            Classifieds in India
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default BreadCrumb;
